// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { anvil as _anvil } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the anvil chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 31337
 * Chain Name: Anvil
 * Default Block Explorer: Not specified
 * Default RPC URL: http://127.0.0.1:8545
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { anvil } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: anvil,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const anvil = createCommon({
	..._anvil,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
